import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Divider, Space } from 'tdesign-react';
import Descriptions from '@/components/Descriptions';
import SaveAsTemplate from './SaveAsTemplate';
import SelectCluster from './SelectCluster';

function SearchHeader({ cluster }) {
  return (
    <Root>
      <SelectCluster />
      {cluster && (
        <Space align='center' size='small' separator={<Divider layout='vertical' />}>
          <Descriptions>
            <Descriptions.Item label='变量模板' value={cluster.stencilName} />
          </Descriptions>
          <SaveAsTemplate />
        </Space>
      )}
    </Root>
  );
}

export default connect((state) => ({
  cluster: state.execVariable.cluster,
}))(SearchHeader);

const Root = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 10px;
  .description-value {
    padding-right: 0;
  }
`;
